import React, { useEffect } from "react";
import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

Sentry.init({
  dsn: "https://53f461ec9610d95accda6adbb98e85df@o4508644087562240.ingest.us.sentry.io/4508646356287488",
  integrations: [
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: [/^\//, /^https:\/\/app.smoothspeak\.ai/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

import { createRoot } from "react-dom/client";
import App from "./components/App";
import { ErrorBoundary } from "./components/ErrorBoundaries";

import axios from "axios";
import Cookies from "js-cookie";
import { Provider } from "react-redux";
import store from "./store";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { checkAuthenticated } from "./components/user/userSlice";
import { PostHogProvider } from "posthog-js/react";

const recaptchaSiteKey = "6LfDvUgqAAAAAJenhC8NS48A-dW2Hhf8KQl9T7qs";

const posthogApiKey = "phc_pH51xUW6Tj2KP9gB3wSEzXJk3PNcjQlNpo0luLhcqVu";
const posthogApiHost = "https://us.i.posthog.com";

const options = {
  api_host: posthogApiHost,
  enable_recording_console_log: true,
};

axios.interceptors.request.use(
  (config) => {
    config.headers["X-CSRFToken"] = Cookies.get("csrftoken");
    config.headers["X-Web-Bundle-Version"] = window.CURRENT_BUNDLE_VERSION;
    config.withCredentials = true;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // User's session has expired, dispatch checkAuthenticated
      store.dispatch(checkAuthenticated());
    }
    return Promise.reject(error);
  }
);

const appDiv = document.getElementById("app");
const root = createRoot(appDiv);
root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <PostHogProvider apiKey={posthogApiKey} options={options}>
        <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
          <App />
        </GoogleReCaptchaProvider>
      </PostHogProvider>
    </Provider>
  </ErrorBoundary>
);
